import { Controller } from 'stimulus'
import LazyLoad from "vanilla-lazyload"

export default class LazyloadingController extends Controller {
  initialize() {
    if (window.lazyLoadInstance) return

    window.lazyLoadInstance = new LazyLoad({
      elements_selector: ".lazy",
      unobserve_entered: true,
    })
  }
 
  connect() {
    this.element.classList.add('lazy')
    window.lazyLoadInstance.update()
  }
}